export const templateForms = [
  {
    id: '1',
    name: 'Blank Form',
    formData: []
  },
  {
    id: '2',
    name: 'Template : Hair - History & Goal Assessment',
    formData: [
    {
        "id" : "B8901DEC-3760-408E-B88E-88A6933D9B48",
        "element" : "Logo",
        "text" : "Logo",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "src" : "https://res.cloudinary.com/clientdiary/image/upload/v1649810616/SalonLogo_fitgj3.png",
        "height" : 150,
        "field_name" : "logo_D5CA20AA-21C5-4C5A-9CF1-EFE74FB0E8FA",
        "center" : true,
        "dirty" : false
    },
    {
        "id" : "2940A911-F98A-4AF2-BB54-47A300D55CFC",
        "element" : "Header",
        "text" : "Header Text",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Hair History &amp; Goal Assessment ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "A9B55DF9-28B5-49A7-8FBC-543D70E9453F",
        "element" : "Paragraph",
        "text" : "Paragraph",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Please fill this out accurately so we can book the correct amount of time for your transformation. ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "DE64D169-AE45-4699-8780-8F38044C19D4",
        "element" : "TwoColumnRow",
        "text" : "Two Column Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "two_col_row_7487573E-6095-4317-A2EB-EE376A6CEF9B",
        "childItems" : [ 
            "A770900E-F5C0-4BC2-B1DB-29F004125286", 
            "E06E7A1A-1F33-4B53-9948-46549003CAC8"
        ],
        "isContainer" : true
    },
    {
        "id" : "8727E00F-74A5-4DFB-82A3-80AED136C8AD",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "AA5538CD-A1CA-42F7-858F-57E7645C725B",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Hair Goals ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "7E2DD280-66DE-4CDF-B85A-8A39DEA26AC7",
        "element" : "TextArea",
        "text" : "Multi-line Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_area_5D968CF1-4A59-412C-8D77-AF3E2AD6F7AC",
        "label" : "Describe your dream hair colour and style. ",
        "dirty" : false
    },
    {
        "id" : "62B40AAD-56C1-4761-AF1A-FEC8B9050CD6",
        "element" : "ThreeColumnRow",
        "text" : "Three Columns Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "three_col_row_FEC23951-D4A3-4F75-B8F3-8463074CBF07",
        "childItems" : [ 
            "643044C4-7E8E-48F4-B348-9089B90EE38C", 
            "DDC19FD5-8AEB-409E-AB2D-F39233480527", 
            "CB7B7A4C-FB35-45E6-9D4C-D26925F5E224"
        ],
        "isContainer" : true
    },
    {
        "id" : "A0EEE206-3419-4367-90F9-E0D96DAF621B",
        "element" : "Range",
        "text" : "Range",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "step" : 1,
        "default_value" : "2",
        "min_value" : 1,
        "max_value" : "3",
        "min_label" : "Fine",
        "max_label" : "Thick",
        "field_name" : "range_39620D75-3085-40FA-B257-4749673F24D9",
        "label" : "Hair Thickness (Fine / Medium / Thick) ",
        "dirty" : false
    },
    {
        "id" : "EEFFEA7D-6C45-4D26-97A8-F2467FD2ACA1",
        "element" : "Rating",
        "text" : "Rating",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "rating_C8DFBAF0-E6F9-4520-99CF-9F678A8EBBA2",
        "label" : "Current Hair Health (1 Star = Damaged, 5 Stars = Virgin/Healthy) ",
        "dirty" : false
    },
    {
        "id" : "DD72AF9F-CADE-4068-9018-E97F2AF0D691",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "B397CC33-D397-4BEE-B139-5D4613B3BBD7",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Terms and Consent ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "14897EFC-DD65-4945-BAC9-FAE7498DB009",
        "element" : "Paragraph",
        "text" : "Paragraph",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Terms should live here. Please update these to match your terms, conditions, and consent reqjirements.  <br><br>EG: I understand that vivid colors may require multiple sessions.... etc ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "6F706B5C-3765-45E2-8DDF-69D2C1E25920",
        "element" : "Signature",
        "text" : "Signature",
        "required" : false,
        "readOnly" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "signature_ED204A27-4C33-4976-8E2E-72FABA1EB913",
        "label" : "Signature"
    },
    {
        "id" : "A770900E-F5C0-4BC2-B1DB-29F004125286",
        "element" : "TextInput",
        "text" : "Text Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_input_77E06202-4226-460B-96A3-08CCCB2DDD7B",
        "label" : "Full Name ",
        "col" : 0,
        "parentId" : "DE64D169-AE45-4699-8780-8F38044C19D4",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "E06E7A1A-1F33-4B53-9948-46549003CAC8",
        "element" : "NumberInput",
        "text" : "Number Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "number_input_09244E8D-E325-4D55-97B7-59A3FAB540B1",
        "label" : "Phone Number ",
        "col" : 1,
        "parentId" : "DE64D169-AE45-4699-8780-8F38044C19D4",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "643044C4-7E8E-48F4-B348-9089B90EE38C",
        "element" : "RadioButtons",
        "text" : "Multiple Choice",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "radiobuttons_DE0BA25D-C2C2-4E9F-B440-7C5635986B18",
        "label" : "Current Colour ",
        "options" : [ 
            {
                "value" : "natural",
                "text" : "Natural",
                "key" : "radiobuttons_option_743EFFF9-5D8E-45E4-A91D-079033681B6E"
            }, 
            {
                "value" : "full_colour",
                "text" : "Full Colour",
                "key" : "radiobuttons_option_847A49C2-C7F8-41EE-9B8D-25384BF4BAB8"
            }, 
            {
                "value" : "highlights",
                "text" : "Highlights",
                "key" : "radiobuttons_option_6A4D27C5-035D-4057-ADB7-099170828896"
            }
        ],
        "col" : 0,
        "parentId" : "62B40AAD-56C1-4761-AF1A-FEC8B9050CD6",
        "parentIndex" : 7,
        "dirty" : false
    },
    {
        "id" : "DDC19FD5-8AEB-409E-AB2D-F39233480527",
        "element" : "Checkboxes",
        "text" : "Checkboxes",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "checkboxes_C5ADE69C-E78A-426C-AC5D-B8D890D21526",
        "label" : "Services Desired ",
        "options" : [ 
            {
                "value" : "cut",
                "text" : "Cut",
                "key" : "checkboxes_option_14DB7B32-D497-4336-BE63-4A7692E6E1F5"
            }, 
            {
                "value" : "colour",
                "text" : "Colour",
                "key" : "checkboxes_option_2654E513-A99A-4FA3-8459-B1DA95D456F4"
            }, 
            {
                "value" : "treatment",
                "text" : "Treatment",
                "key" : "checkboxes_option_72CA9388-6B81-412B-9FE9-4075E9472345"
            }, 
            {
                "value" : "extensions",
                "text" : "Extensions",
                "key" : "C1E7B119-A101-4247-BF94-5A5C6A6FB93A"
            }
        ],
        "col" : 1,
        "parentId" : "62B40AAD-56C1-4761-AF1A-FEC8B9050CD6",
        "parentIndex" : 7,
        "dirty" : false
    },
    {
        "id" : "CB7B7A4C-FB35-45E6-9D4C-D26925F5E224",
        "element" : "DatePicker",
        "text" : "Date",
        "required" : false,
        "readOnly" : false,
        "defaultToday" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dateFormat" : "dd/MM/yyyy",
        "timeFormat" : "hh:mm aa",
        "showTimeSelect" : false,
        "showTimeSelectOnly" : false,
        "showTimeInput" : false,
        "field_name" : "date_picker_E56B19FF-08AE-4F72-98C0-A80C66118330",
        "label" : "Approximate date of last professional Colour ",
        "col" : 2,
        "parentId" : "62B40AAD-56C1-4761-AF1A-FEC8B9050CD6",
        "parentIndex" : 7,
        "dirty" : false
    }
    ]
  },
  {
    id: '3',
    name: 'Template : Beauty - Skin Health Deep-Dive',
    formData: [
    {
        "id" : "FB9AC94B-EE48-4391-AE1D-0E24E0D87EB9",
        "element" : "Logo",
        "text" : "Logo",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "src" : "https://res.cloudinary.com/clientdiary/image/upload/v1649810616/SalonLogo_fitgj3.png",
        "height" : 150,
        "field_name" : "logo_3219D1B7-1769-4806-B8C2-FD3F8E1FC2DF",
        "center" : true,
        "dirty" : false
    },
    {
        "id" : "BA123B45-6F60-4111-80F4-E2F4B565B639",
        "element" : "Header",
        "text" : "Header Text",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Facial &amp; Skin Treatment Intake ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "5B7EA948-6FED-4810-9FE9-CAFBC11EAD17",
        "element" : "Paragraph",
        "text" : "Paragraph",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Your safety is our priority. Please disclose all active ingredients in your current routine. ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "D265D428-2C17-46A5-BF63-690D11DB2B16",
        "element" : "TwoColumnRow",
        "text" : "Two Column Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "two_col_row_0B2D43C0-374A-4359-8449-AA9FC785B755",
        "childItems" : [ 
            "29055FFB-358B-4D4A-A44A-EE416D71FB1F", 
            "817CCBAC-BEE8-4DAF-84B1-B1E4474AEDB1"
        ],
        "isContainer" : true
    },
    {
        "id" : "8684790B-9AA5-462D-94F6-106DA86BBD74",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "638802D2-8124-443E-BFD1-A1FA08F00FE2",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Skin Profile ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "5044BA4A-36EC-4546-977A-9F164A0B421D",
        "element" : "Range",
        "text" : "Range",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "step" : 1,
        "default_value" : 3,
        "min_value" : 1,
        "max_value" : 5,
        "min_label" : "Not Sensitive",
        "max_label" : "Highly Reactive",
        "field_name" : "range_EF26D668-A9C7-454B-9F88-06524AEF80C0",
        "label" : "Skin Sensitivity: (Not Sensitive → Highly Reactive) ",
        "dirty" : false
    },
    {
        "id" : "DDB24F06-E4B9-4D2D-B449-98C877839645",
        "element" : "RadioButtons",
        "text" : "Multiple Choice",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "radiobuttons_9FB887AF-EC50-4B83-AF51-858CD9B1C7BA",
        "label" : "Primary Skin Concern ",
        "options" : [ 
            {
                "value" : "aging",
                "text" : "Aging",
                "key" : "radiobuttons_option_CFDAAA45-7C9E-411F-A94F-8F44E5B1A758"
            }, 
            {
                "value" : "acne",
                "text" : "Acne",
                "key" : "radiobuttons_option_291837A6-297E-4EDE-A07E-30B3ED3CC679"
            }, 
            {
                "value" : "pigmentation",
                "text" : "Pigmentation",
                "key" : "radiobuttons_option_4159FE18-81D9-477B-A765-5A4D75B59F6D"
            }, 
            {
                "value" : "hydration",
                "text" : "Hydration",
                "key" : "20B7C12F-849E-4AB7-99EA-82123697BA34"
            }
        ],
        "dirty" : false
    },
    {
        "id" : "AF4700C7-B93F-42FC-8513-92145012AF56",
        "element" : "TwoColumnRow",
        "text" : "Two Column Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "two_col_row_305E446F-258B-4003-825C-A144878DF391",
        "childItems" : [ 
            "CCB32ABB-DBF3-4723-AA50-264F564DBE85", 
            "13C435E6-40D6-4F7B-A372-5540B29E3D98"
        ],
        "isContainer" : true
    },
    {
        "id" : "5A109A8F-6B9F-43FF-A22D-188C24263861",
        "element" : "TextArea",
        "text" : "Multi-line Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_area_A78F2720-6E75-4CD5-AD98-663F435FAEDD",
        "label" : "List any known allergies (especially nuts, latex, or shellfish). ",
        "dirty" : false
    },
    {
        "id" : "03A5D3DC-AC53-4345-816E-ED8268C83AD0",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "8FDA87F9-7683-4ED1-BFE5-8F027681A2FD",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Legal Disclosure ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "10182BE4-6C27-43B9-82DC-F5EAB553AB9F",
        "element" : "Paragraph",
        "text" : "Paragraph",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Please enter your actual Legal Disclosure here... Eg:  I confirm I have not had a chemical peel or Botox in the last 14 days. etc etc ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "33CA3737-5143-4767-BFB8-A74FD2F2F34C",
        "element" : "Signature",
        "text" : "Signature",
        "required" : false,
        "readOnly" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "signature_EAA03EE7-DEA5-4081-A5CE-1341A0BEFAAB",
        "label" : "Signature"
    },
    {
        "id" : "29055FFB-358B-4D4A-A44A-EE416D71FB1F",
        "element" : "TextInput",
        "text" : "Text Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_input_BF52B06F-42DE-40C5-9B02-45F99B3F1D41",
        "label" : "Emergency Contact Name ",
        "col" : 0,
        "parentId" : "D265D428-2C17-46A5-BF63-690D11DB2B16",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "817CCBAC-BEE8-4DAF-84B1-B1E4474AEDB1",
        "element" : "NumberInput",
        "text" : "Number Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "number_input_9DF6E22F-DC42-45FF-B09D-5EF1C2A12EC4",
        "label" : "Emergency Contact Phone ",
        "col" : 1,
        "parentId" : "D265D428-2C17-46A5-BF63-690D11DB2B16",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "CCB32ABB-DBF3-4723-AA50-264F564DBE85",
        "element" : "Checkboxes",
        "text" : "Checkboxes",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "checkboxes_67D0AC33-9888-4904-B6F4-CF052B5EB056",
        "label" : "Active Ingredients ",
        "options" : [ 
            {
                "value" : "retinol",
                "text" : "Retinol",
                "key" : "checkboxes_option_F3CCE3CF-0E96-4AAB-BEE6-C4D9A156DDA5"
            }, 
            {
                "value" : "vitamin_c",
                "text" : "Vitamin C",
                "key" : "checkboxes_option_CC09F4EE-F6E6-49CE-8DFD-DADF6653C027"
            }, 
            {
                "value" : "aha_bha",
                "text" : "AHA/BHA",
                "key" : "checkboxes_option_0B7653F0-0E07-41E0-9FD0-B11717954F00"
            }, 
            {
                "value" : "accutane",
                "text" : "Accutane",
                "key" : "CFB04098-B7A6-425E-BFF7-4AA69BAD3B53"
            }
        ],
        "col" : 0,
        "parentId" : "AF4700C7-B93F-42FC-8513-92145012AF56",
        "parentIndex" : 8,
        "dirty" : false
    },
    {
        "id" : "13C435E6-40D6-4F7B-A372-5540B29E3D98",
        "element" : "Rating",
        "text" : "Rating",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "rating_992A3F05-B958-4DA1-9C5C-555468104BBA",
        "label" : "Current Sunscreen Usage (Daily → Never) ",
        "col" : 1,
        "parentId" : "AF4700C7-B93F-42FC-8513-92145012AF56",
        "parentIndex" : 8,
        "dirty" : false
    }
    ]
  },
  {
    id: '4',
    name: 'Template : Tattoo & Piercing -  Project & Safety Release',
    formData: [
    {
        "id" : "3620771C-3F0C-4377-A1CE-09928BA5FE32",
        "element" : "Logo",
        "text" : "Logo",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "src" : "https://res.cloudinary.com/clientdiary/image/upload/v1649810616/SalonLogo_fitgj3.png",
        "height" : 150,
        "field_name" : "logo_4459B69C-851D-4335-BF65-4C26C8D037B0",
        "center" : true,
        "dirty" : false
    },
    {
        "id" : "5C0386DD-4816-46EF-9206-303E24B266BA",
        "element" : "Header",
        "text" : "Header Text",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Tattoo Project Proposal &amp; Waiver ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "979EA37A-9CBD-4196-8171-6994FB940532",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "DFE31BBF-050B-4604-A558-F053B81B1596",
        "element" : "FourColumnRow",
        "text" : "Four Columns Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "four_col_row_6A0F8995-9900-4991-9ED6-8D9E17CE1ABD",
        "childItems" : [ 
            "F0B21F75-0725-44ED-8FD0-329370379D7A", 
            "E7F2C210-F9F8-45FA-A70E-5AC2AA85A2EC", 
            "B47800D3-62BB-4745-A0CA-F66750A3D9DC", 
            "2059D5E9-4D29-43DB-9CF7-47B61F9602E5"
        ],
        "isContainer" : true
    },
    {
        "id" : "502A9EA6-CE81-4718-9964-F03F46F12F34",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Placement &amp; Detail ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "FAF3A807-FC13-4FD6-986D-3DD90D612D25",
        "element" : "TextArea",
        "text" : "Multi-line Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_area_46F3A12A-6674-4FFB-91A4-7C4A2BF1E6CF",
        "label" : "Describe where on the body this is going and any specific details. ",
        "dirty" : false
    },
    {
        "id" : "FB349688-8F83-405E-9DB7-3C1E05548EAC",
        "element" : "Range",
        "text" : "Range",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "step" : 1,
        "default_value" : 3,
        "min_value" : 1,
        "max_value" : 5,
        "min_label" : "Low",
        "max_label" : "High",
        "field_name" : "range_993BB2F6-52C8-4E50-825E-DFDF401AAAB7",
        "label" : "Pain Threshold: (Low → High) ",
        "dirty" : false
    },
    {
        "id" : "C11C1B4B-21FF-4760-98D5-ACC4135A203E",
        "element" : "Checkboxes",
        "text" : "Checkboxes",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "checkboxes_DBF031CC-8280-43FA-8EB5-1D24A5763E4A",
        "label" : "Medical History ",
        "options" : [ 
            {
                "value" : "diabetes",
                "text" : "Diabetes",
                "key" : "checkboxes_option_A6D23ED3-378E-4181-AF41-CE1E6757D8A9"
            }, 
            {
                "value" : "epilepsy",
                "text" : "Epilepsy",
                "key" : "checkboxes_option_4B8AA0B1-0B34-405A-BB39-826C5F6ECB95"
            }, 
            {
                "value" : "blood_thinners",
                "text" : "Blood Thinners",
                "key" : "checkboxes_option_67E43FAD-2584-4206-8208-8D2AEB406F38"
            }, 
            {
                "value" : "fainting",
                "text" : "Fainting",
                "key" : "05DA6E77-0113-422C-959F-2C5B8698B41D"
            }
        ],
        "dirty" : false
    },
    {
        "id" : "82C51F91-3950-4603-88BF-1E9F495DDC8E",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "ED1DD099-56E5-460D-8444-BD9B672661B8",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Artist Match ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "06A78E6F-924D-4D95-97A9-5D3ED673359A",
        "element" : "Rating",
        "text" : "Rating",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "rating_251418E0-05ED-4436-BAF9-F4C6816C5AF9",
        "label" : "How much creative freedom are you giving the artist? (1 = None, 5 = Full Freedom) ",
        "dirty" : false
    },
    {
        "id" : "05095633-447E-48F0-B83F-6E6E70134897",
        "element" : "Paragraph",
        "text" : "Paragraph",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Please place your real disclaimer here.  EG: By signing below, I certify I am 18+ and not under the influence of alcohol. etc etc ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "9B844AF7-F19F-4F63-8336-99F44938093A",
        "element" : "Signature",
        "text" : "Signature",
        "required" : false,
        "readOnly" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "signature_56BE3B84-FFB6-4C93-AD3A-08A8F80AD1C6",
        "label" : "Signature"
    },
    {
        "id" : "F0B21F75-0725-44ED-8FD0-329370379D7A",
        "element" : "TextInput",
        "text" : "Text Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_input_C6A962B0-824F-4C3E-9BF2-E8152362CEC1",
        "label" : "Subject/Theme ",
        "col" : 0,
        "parentId" : "DFE31BBF-050B-4604-A558-F053B81B1596",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "E7F2C210-F9F8-45FA-A70E-5AC2AA85A2EC",
        "element" : "NumberInput",
        "text" : "Number Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "number_input_23D69BC5-26EE-4103-89BD-EF0EFE89F0F7",
        "label" : "Approx Size (cm) ",
        "col" : 1,
        "parentId" : "DFE31BBF-050B-4604-A558-F053B81B1596",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "B47800D3-62BB-4745-A0CA-F66750A3D9DC",
        "element" : "RadioButtons",
        "text" : "Multiple Choice",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "radiobuttons_2DD414D7-ACC0-4D6F-A7FC-993DE1EBE7B8",
        "label" : "Style ",
        "options" : [ 
            {
                "value" : "fine_line",
                "text" : "Fine Line",
                "key" : "radiobuttons_option_6E17627B-40F6-45D3-9D58-51F07B3C8693"
            }, 
            {
                "value" : "traditional",
                "text" : "Traditional",
                "key" : "radiobuttons_option_2631DBD5-0D78-4941-9535-DCD1773D44D7"
            }, 
            {
                "value" : "realism",
                "text" : "Realism",
                "key" : "radiobuttons_option_FC7BD6E4-920A-45D1-8522-4ABEDA961811"
            }
        ],
        "col" : 2,
        "parentId" : "DFE31BBF-050B-4604-A558-F053B81B1596",
        "parentIndex" : 3,
        "dirty" : false
    },
    {
        "id" : "2059D5E9-4D29-43DB-9CF7-47B61F9602E5",
        "element" : "DatePicker",
        "text" : "Date",
        "required" : false,
        "readOnly" : false,
        "defaultToday" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dateFormat" : "dd/MM/yyyy",
        "timeFormat" : "hh:mm aa",
        "showTimeSelect" : false,
        "showTimeSelectOnly" : false,
        "showTimeInput" : false,
        "field_name" : "date_picker_8D6B9DF8-D078-49EA-9F72-282CCE1E9B60",
        "label" : "Approx date of last tattoo ",
        "col" : 3,
        "parentId" : "DFE31BBF-050B-4604-A558-F053B81B1596",
        "parentIndex" : 3,
        "dirty" : false
    }
    ]
  },
  {
    id: '5',
    name: 'Template : General Services - Onboarding & Feedback',
    formData: [
    {
        "id" : "2EE82CB7-FA4D-4E1E-A379-5110157C12A9",
        "element" : "Logo",
        "text" : "Logo",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "src" : "https://res.cloudinary.com/clientdiary/image/upload/v1649810616/SalonLogo_fitgj3.png",
        "height" : 150,
        "field_name" : "logo_5D5C225C-966E-4302-AF09-EA2BF7476AE6",
        "center" : true,
        "dirty" : false
    },
    {
        "id" : "22264870-4FC1-4178-AB74-A1BBE5BDF7A8",
        "element" : "Header",
        "text" : "Header Text",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "New Client Onboarding ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "956A6DD5-751B-4EB5-AA7D-A98B6AC80031",
        "element" : "TwoColumnRow",
        "text" : "Two Column Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "two_col_row_C5406AB1-853F-4831-82A4-EA8ACBE815D5",
        "childItems" : [ 
            "AE9BCDA4-8A14-4558-9EE9-A42A3A5820B3", 
            "1EA2B764-4C8D-476D-9E0B-4863A8D0A793"
        ],
        "isContainer" : true
    },
    {
        "id" : "E4CEBC7E-9FBE-422A-AFD5-40952E15BBD0",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "22E8E98B-B745-4CDD-8C43-94DD0F7E645F",
        "element" : "Label",
        "text" : "Label",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "Service Requirements ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "4E2FBD25-226F-42C0-9573-7B33C7B05175",
        "element" : "TextArea",
        "text" : "Multi-line Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_area_244F4CBA-34AC-4E0B-B2B6-CE2A974C61BB",
        "label" : "Please provide any specific instructions for us. ",
        "dirty" : false
    },
    {
        "id" : "CAED1D2B-9FBB-40F8-A194-373B04BEB827",
        "element" : "ThreeColumnRow",
        "text" : "Three Columns Row",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "three_col_row_89E2B3E1-797B-4160-B131-94E71B3942C9",
        "childItems" : [ 
            "453BDEF6-401D-4D0D-B9E5-7415465E02E8", 
            "F9BDC8BA-63BB-45A5-A87B-1FF2FA733E86", 
            "6E5E07C7-0694-4B04-87EF-428495155C6B"
        ],
        "isContainer" : true
    },
    {
        "id" : "5443E2E9-274B-4465-85DE-716FB62099BB",
        "element" : "Range",
        "text" : "Range",
        "required" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "step" : 1,
        "default_value" : 3,
        "min_value" : 1,
        "max_value" : 5,
        "min_label" : "Whenever",
        "max_label" : "ASAP",
        "field_name" : "range_EF4E826D-D55D-4FE9-82CC-864B80FD0627",
        "label" : "Urgency Level: (Whenever → ASAP) ",
        "dirty" : false
    },
    {
        "id" : "0EA7A4FF-331C-4AC2-BB6F-E3AD989E5310",
        "element" : "Rating",
        "text" : "Rating",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "rating_A525C334-5DFC-4BA8-8DE4-6E7226287B87",
        "label" : "Importance of Quiet/Silent Service: (1 = Chatty, 5 = Silent) ",
        "dirty" : false
    },
    {
        "id" : "1F57962D-9E9E-480F-B383-DC28D366B971",
        "element" : "LineBreak",
        "text" : "Line Break",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true
    },
    {
        "id" : "F722BA47-6456-4143-A1CA-60EA171647E5",
        "element" : "Paragraph",
        "text" : "Paragraph",
        "static" : true,
        "required" : false,
        "bold" : false,
        "italic" : false,
        "content" : "We value your privacy. Your data is stored securely. ",
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dirty" : false
    },
    {
        "id" : "AE9BCDA4-8A14-4558-9EE9-A42A3A5820B3",
        "element" : "TextInput",
        "text" : "Text Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "text_input_14D1643C-AA44-407F-82D6-4F26CBC05541",
        "label" : "How did you hear about us? ",
        "col" : 0,
        "parentId" : "956A6DD5-751B-4EB5-AA7D-A98B6AC80031",
        "parentIndex" : 2,
        "dirty" : false
    },
    {
        "id" : "1EA2B764-4C8D-476D-9E0B-4863A8D0A793",
        "element" : "DatePicker",
        "text" : "Date",
        "required" : false,
        "readOnly" : false,
        "defaultToday" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "dateFormat" : "dd/MM/yyyy",
        "timeFormat" : "hh:mm aa",
        "showTimeSelect" : false,
        "showTimeSelectOnly" : false,
        "showTimeInput" : false,
        "field_name" : "date_picker_590A4145-30CD-46BE-8131-9323C5C5EA46",
        "label" : "Today's Date ",
        "col" : 1,
        "parentId" : "956A6DD5-751B-4EB5-AA7D-A98B6AC80031",
        "parentIndex" : 2,
        "dirty" : false
    },
    {
        "id" : "453BDEF6-401D-4D0D-B9E5-7415465E02E8",
        "element" : "RadioButtons",
        "text" : "Multiple Choice",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "radiobuttons_FFF40D2A-E710-4791-8B20-B7EF21F8712B",
        "label" : "Frequency ",
        "options" : [ 
            {
                "value" : "weekly",
                "text" : "Weekly",
                "key" : "radiobuttons_option_C9104A7F-CDC9-4027-ACA8-57912F49A550"
            }, 
            {
                "value" : "monthly",
                "text" : "Monthly",
                "key" : "radiobuttons_option_C7364D6A-50A5-4D4E-8C4F-393B5ADEE5D3"
            }, 
            {
                "value" : "once_only",
                "text" : "Once only",
                "key" : "radiobuttons_option_A2E296C1-FD1D-4522-9226-302B1239B0F1"
            }
        ],
        "col" : 0,
        "parentId" : "CAED1D2B-9FBB-40F8-A194-373B04BEB827",
        "parentIndex" : 6,
        "dirty" : false
    },
    {
        "id" : "F9BDC8BA-63BB-45A5-A87B-1FF2FA733E86",
        "element" : "NumberInput",
        "text" : "Number Input",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "number_input_AA305295-725D-459E-A0F1-F0D2AC8D1B6A",
        "label" : "Budget Limit ($) ",
        "col" : 1,
        "parentId" : "CAED1D2B-9FBB-40F8-A194-373B04BEB827",
        "parentIndex" : 6,
        "dirty" : false
    },
    {
        "id" : "6E5E07C7-0694-4B04-87EF-428495155C6B",
        "element" : "Checkboxes",
        "text" : "Checkboxes",
        "required" : false,
        "canHaveAnswer" : true,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "checkboxes_58454F54-79AF-4345-A2B0-D8BFE3C3207C",
        "label" : "Contact Preference ",
        "options" : [ 
            {
                "value" : "sms",
                "text" : "SMS",
                "key" : "checkboxes_option_280914B3-520A-40FD-A4E4-DCF22BFE340A"
            }, 
            {
                "value" : "email",
                "text" : "Email",
                "key" : "checkboxes_option_66F6505F-3678-4E81-9692-542659846FC7"
            }, 
            {
                "value" : "phone",
                "text" : "Phone",
                "key" : "checkboxes_option_746D1CE8-B41F-4339-84DE-EC068C44A1A8"
            }
        ],
        "col" : 2,
        "parentId" : "CAED1D2B-9FBB-40F8-A194-373B04BEB827",
        "parentIndex" : 6,
        "dirty" : false
    },
    {
        "id" : "A3CC706F-D89A-41A1-83B6-DA5DC0F96830",
        "element" : "Signature",
        "text" : "Signature",
        "required" : false,
        "readOnly" : false,
        "canHavePageBreakBefore" : true,
        "canHaveAlternateForm" : true,
        "canHaveDisplayHorizontal" : true,
        "canHaveOptionCorrect" : true,
        "canHaveOptionValue" : true,
        "canPopulateFromApi" : true,
        "field_name" : "signature_3B9169C3-5EF4-4345-8B60-EE648CED70E0",
        "label" : "Signature"
    }
    ]
  },
]